import MenuActions from "common/components/MenuActions/MenuActions";

const { Button, Tooltip } = require("@mui/material");

const getUsersColumnsBase = () => {
    return [
        { field: "first_name", headerName: "Nombre", width: 150 },
        { field: "email", headerName: "Email", width: 300 },
    ];
};

const renderActionButtons = (
    params,
    setDialogContent,
    openModal,
    isSuperAdmin,
    openResetPasswordConfirmation
) => {
    const options = [
        {
            label: isSuperAdmin ? "Asignar establecimiento" : "Asignar Rol",
            handleClick: () => {
                setDialogContent("establishment");
                openModal(params.row);
            },
        },
        {
            label: "Ver Establecimientos",
            handleClick: () => {
                setDialogContent("establishmentList");
                openModal(params.row);
            },
        },
        {
            label: "Ver",
            handleClick: () => {
                setDialogContent("infoUser");
                openModal(params.row);
            },
        },
        {
            label: "- - - - - - - - - - - - - - - - - - - -",
            handleClick: () => {
                return;
            },
            hide: !isSuperAdmin,
            disabled: true,
        },
        {
            label: (
                <Tooltip
                    enterTouchDelay={0}
                    leaveTouchDelay={15000}
                    disableTouchListener={false} title="Al resetear la contraseña de un usuario, esta pasará a tener un nuevo valor conocida solo por el SUPERADMIN, quien será responsable de informarle  al usuario (via mail o por el medio que considere) cuál es su nueva contraseña. Al hacerlo, deberá pedirle que la primera vez que ingrese a la plataforma con la nueva contraseña, ingrese a su perfil y  la cambie por otra más segura">
                    <span>Resetear contraseña</span>
                </Tooltip>
            ),
            handleClick: () => {
                setDialogContent("resetPassword");
                openResetPasswordConfirmation(params.row);
            },
            hide: !isSuperAdmin,
        },
    ];
    return <MenuActions options={options} />;
};

const getUsersColumnsWithoutPending = (
    setDialogContent,
    openModal,
    isSuperAdmin,
    openResetPasswordConfirmation
) => {
    return [
        ...getUsersColumnsBase(),
        {
            field: "actions",
            headerName: "Acciones",
            width: 830,
            hideable: true,
            renderCell: (params) => {
                return renderActionButtons(
                    params,
                    setDialogContent,
                    openModal,
                    isSuperAdmin,
                    openResetPasswordConfirmation
                );
            },
        },
    ];
};

const getUsersColumnsWithPending = (setDialogContent, openModal) => {
    return [
        ...getUsersColumnsBase(),
        {
            field: "actions",
            headerName: "Acciones",
            width: 600,
            hideable: true,
            renderCell: (params) => {
                return (
                    <div>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => {
                                setDialogContent("role");
                                openModal(params.row);
                            }}
                        >
                            Ver roles solicitados
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            style={{ marginLeft: "10px" }}
                            onClick={() => {
                                setDialogContent("establishmentList");
                                openModal(params.row);
                            }}
                        >
                            Ver establecimientos
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            sx={{ marginLeft: "10px" }}
                            onClick={() => {
                                setDialogContent("infoUser");
                                openModal(params.row);
                            }}
                        >
                            Ver
                        </Button>
                    </div>
                );
            },
        },
    ];
};

const getUsersColumnsAcceptOrReject = (openModal, setAccept, setDialogContent, setSelectedUser) => {
    return [
        ...getUsersColumnsBase(),
        {
            field: "role",
            headerName: "Rol",
            width: 200
        },
        {
            field: "actions",
            headerName: "Acciones",
            width: 600,
            hideable: true,
            renderCell: (params) => {
                return (
                    <div>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => {
                                setDialogContent("confirmation");
                                openModal(params.row.id);
                                setAccept(true);
                            }}
                        >
                            Aceptar
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            sx={{ marginLeft: "10px" }}
                            onClick={() => {
                                setDialogContent("confirmation");
                                openModal(params.row.id);
                                setAccept(false);
                            }}
                        >
                            Rechazar
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            sx={{ marginLeft: "10px" }}
                            onClick={() => {
                                setSelectedUser({
                                    first_name: params.row.first_name,
                                    email: params.row.email,
                                    birthday: params.row.birthday,
                                    last_name: params.row.last_name,
                                    dni: params.row.dni,
                                    role: params.row.role
                                });
                                openModal(params.row);
                                setDialogContent("infoUser");
                            }}
                        >
                            Ver
                        </Button>
                    </div>
                );
            },
        },
    ];
};

const getUsersColumns = {
    getUsersColumnsWithoutPending,
    getUsersColumnsWithPending,
    getUsersColumnsBase,
    getUsersColumnsAcceptOrReject,
};

export default getUsersColumns;
